import { TherapeuticStyle } from '@uplift/types';
import { restClient } from '../client';

export type GetTheraputicStylesResponse = {
  data: TherapeuticStyle[];
};

export const getTherapeuticStyles = () =>
  restClient.request<GetTheraputicStylesResponse>('/api/v1/therapeutic_styles');
